import { Columns } from '@shared/interfaces/table/column-config';
import { ConnectionPointDto } from '@app/api/nts';

// Section: Key (Nøgle)
// Adds key-related fields to the Connection Point overview.
// Note: The ConnectionPointDto currently does not contain these properties yet.
// To allow the UI to compile and render the section header and future values,
// we cast the constant to Columns<ConnectionPointDto>[] intentionally.
export const connectionpointKeyDetailsMasterData: Columns<ConnectionPointDto>[] = [
  {
    title: 'connectionpoint.keyFields.number',
    key: 'accessKey.number',
    hideIfNull: true,
  },
  {
    title: 'connectionpoint.keyFields.placementType',
    key: 'accessKey.placementType',
    hideIfNull: true,
  },
  {
    title: 'connectionpoint.keyFields.code',
    key: 'accessKey.code',
    hideIfNull: true,
  },
  {
    title: 'connectionpoint.keyFields.remarks',
    key: 'accessKey.remarks',
    hideIfNull: true,
  },
  {
    title: 'connectionpoint.keyFields.facility',
    key: 'accessKey.facility',
    hideIfNull: true,
  },
];
